module.exports = __webpack_public_path__ + "static/media/Changes occurs at IAM level.aacb8aea.png";